import {BaseApiModel} from "../../../infrastructure/models/base-api-model";
import {CompetitorCompetitionsDomainModel} from "../../common/competitor/models/competitor-competitions.domain-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";

export class CompetitorsResponseDomainModel extends BaseApiModel {
  competitors: Array<CompetitorCompetitionsDomainModel>;
  competitions: Array<CompetitionDomainModel>;

  constructor(competitorCompetitionsDomainModel: Array<CompetitorCompetitionsDomainModel>, competitions: Array<CompetitionDomainModel>) {
    super();
    
    this.competitors = competitorCompetitionsDomainModel;
    this.competitions = competitions;
  }
}
